module.exports = __webpack_public_path__ + "img/dark-road-trees.150a1075.jpg";